import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Card, CardHeader, Col, Form, Input } from 'reactstrap';
import errorImg from '../../assets/images/search-not-found.png';
import SearchBar from './SearchBar';
import { AddNew } from '../../Constant';
import { FiPlusSquare, FiUpload } from 'react-icons/fi';
import { useMemo } from 'react';
import msToTime from '../../Utils/helper/msToTime';
import convertSize from 'convert-size';
import FileMainContent from './FileMainContent';
import { Image } from '../../AbstractElements';

const FileContent = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [myfile, setMyFile] = useState([]);

  useMemo(() => {
    axios.get(`${process.env.PUBLIC_URL}/api/files.json`).then((response) => {
      setMyFile(response.data);
    });
  }, []);

  // eslint-disable-next-line array-callback-return
  const filelist = myfile.filter((data) => {
    if (searchTerm == null) return data;
    if (data.name.toLowerCase().includes(searchTerm.toLowerCase())) {
      return data;
    }
  });

  const getFile = () => {
    document.getElementById('upfile').click();
  };
  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const onFileUpload = () => {
    const date = new Date();
    const time = msToTime(date.getMilliseconds(), 'ago', 'long');
    let myfiles = [...myfile];
    if (selectedFile !== null) {
      myfiles.push({
        id: myfile.length + 1,
        name: `${selectedFile.name}`,
        size: `${convertSize(selectedFile.size)}`,
        modify: `${time}`,
        icon: 'f-22 fa fa-file-text-o txt-info',
        fileCount: 1,
      });

      setMyFile(myfiles);
      toast.success('File Upload Successfully !');
    } else {
      toast.error('Please Select at least one file !');
    }
  };

  return (
    <Col md='12' xl='9' className='box-col-70'>
      <div className='file-content'>
        <Card>
          <CardHeader>
            <div className='d-md-flex d-sm-block'>
              <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
              <div className='flex-grow-1 text-end'>
                <Form className='d-inline-flex'>
                  <div className='btn btn-primary' onClick={getFile}>
                    <FiPlusSquare className='me-1' />
                    {AddNew}
                  </div>
                  <div style={{ height: '0px', width: '0px', overflow: 'hidden' }}>
                    <Input id='upfile' multiple type='file' onChange={(e) => onFileChange(e)} />
                  </div>
                </Form>
                <div className='btn btn-outline-primary ms-2' onClick={onFileUpload}>
                  <FiUpload className='me-1' />
                  {'Upload'}
                </div>
              </div>
            </div>
          </CardHeader>
          {filelist.length ? <FileMainContent searchTerm={searchTerm} filelist={filelist} myfile={myfile} /> : <Image className='img-fluid m-auto' src={errorImg} alt='' />}
        </Card>
      </div>
    </Col>
  );
};
export default FileContent;
